import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import VerifyEmail from './pages/VerifyEmail';
import PublicProfile from './pages/PublicProfile';
import ResetPassword from './pages/ResetPassword';
import MerchantBankLinked from './pages/MerchantBankLinked';
import ExtensionDownload from './pages/ExtensionDownload';
import About from './pages/About';
import TempStart from './pages/TempStart';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import Contact from './pages/Contact';
import apiService from './services/api';
import './styles/App.css';

const ADMIN_ORIGIN = 'https://admin.gethomecrowd.com';

const ADMIN_PREFIXES = [
  '/staff',
  '/superuser',
  '/embed-tester',
  '/admin',
  '/rewards',
  '/onboarding',
  '/merchants',
  '/docs',
  '/early-access-overview',
  '/reward-selection',
  '/resources',
  '/preview',
];

function isAdminPath(pathname) {
  return ADMIN_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

function AdminPathRedirect() {
  const location = useLocation();

  useEffect(() => {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return;
    if (!isAdminPath(location.pathname)) return;
    window.location.replace(
      `${ADMIN_ORIGIN}${location.pathname}${location.search}${location.hash}`
    );
  }, [location]);

  return null;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(apiService.isAuthenticated());

  useEffect(() => {
    const handleStorageChange = () => {
      setIsAuthenticated(apiService.isAuthenticated());
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleAuthChange = () => {
    setIsAuthenticated(apiService.isAuthenticated());
  };

  return (
    <Router>
      <div className="app">
        <AdminPathRedirect />
        <Routes>
          <Route
            path="/login/"
            element={isAuthenticated ? <Navigate to="/" replace /> : <Login onAuthChange={handleAuthChange} />}
          />
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/" replace /> : <Login onAuthChange={handleAuthChange} />}
          />

          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/verify-email/" element={<VerifyEmail />} />
          <Route path="/mobile/verify-email" element={<VerifyEmail />} />
          <Route path="/mobile/verify-email/" element={<VerifyEmail />} />
          <Route path="/hc_prof/:fanId" element={<PublicProfile />} />
          <Route path="/hc_prof/:fanId/" element={<PublicProfile />} />
          <Route path="/mobile/u/:fanId" element={<PublicProfile />} />
          <Route path="/mobile/u/:fanId/" element={<PublicProfile />} />
          <Route path="/mobile/reset-password" element={<ResetPassword />} />
          <Route path="/mobile/reset-password/" element={<ResetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/" element={<ResetPassword />} />

          {/* Public: where Stripe returns a merchant after ACH bank setup. They
              have no Homecrowd account, so this must stay outside PrivateRoute. */}
          <Route path="/merchant/bank-linked" element={<MerchantBankLinked />} />
          <Route path="/merchant/bank-linked/" element={<MerchantBankLinked />} />

          <Route path="/extension-download/" element={<ExtensionDownload />} />
          <Route path="/about/" element={<About />} />
          <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions/" element={<TermsAndConditions />} />
          <Route path="/support/" element={<Contact />} />

          <Route path="/" element={<TempStart />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
